var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Prop, Vue, } from "vue-property-decorator";
import GrindingDropDown from "../components/articleattributes/grindingdropdown.vue";
import { GrindingOption, } from "./utilities/articleeditdata";
let GrindingForm = class GrindingForm extends Vue {
    constructor() {
        super(...arguments);
        this.option = GrindingOption.none;
    }
    valueChanged() { return this.option; }
    onChange(o) {
        this.option = o;
        this.valueChanged();
    }
    created() { this.option = this.defaultOption; }
};
__decorate([
    Prop({ required: true })
], GrindingForm.prototype, "defaultOption", void 0);
__decorate([
    Prop({ required: true })
], GrindingForm.prototype, "disabled", void 0);
__decorate([
    Prop({ required: true })
], GrindingForm.prototype, "shopConfig", void 0);
__decorate([
    Emit()
], GrindingForm.prototype, "valueChanged", null);
GrindingForm = __decorate([
    Component({
        components: {
            GrindingDropDown,
        },
        name: "GrindingForm",
    })
], GrindingForm);
export default GrindingForm;
